import Hint from '../components/Hint'
import Screenshot, { ScreenshotRef } from '../components/Screenshot'
import { Page } from './types'

const render = () => (
    <>
        <div className="row">
            <div className="col-8">
            <ul>
                <li>Scroll until you see the newly created pool.</li>
                    <li>At the bottom right of that panel, click the "Download" icon <ScreenshotRef label="1"/></li>
                    <li>Confirm that you want to create a new API key</li>
                    <li>Enter a name for your application and click <i>Create</i></li>
                    <li>Ignore the API key but click the <i>Download</i> button</li>
                </ul>
                <p>You can view the downloaded file in a text editor. It specifies your credentials and the 
                    newly created pool using the <code>CLOUDPOOL</code> parameter. Note how we created a new API key
                    for use in your application. You can view the details by clicking <i>Users</i> on the left side
                    of the screen and then <i>API Keys</i>. Here you can see, change and revoke your API key.
                </p>
                <Hint>
                    Pools define a group of one or more machines that will start together and form a cluster that can solve models submitted by your client code.
                    API keys provide full access to all pools. By downloading the license from the <i>Pools</i> page, the license file will automatically contain
                    instructions to use the chosen pool when submitting a model. You could also download the license from the <i>Account &gt; Licenses</i> panel
                    instead.
                </Hint>  
            </div>
            <aside className="screenshots col-4">
                <Screenshot label="1" src="10-download-pool.png"/>            
            </aside>
        </div>
                
    </>
)

const DownloadCloudLicenseFile : Page<{}> = { key: 'download-cloud-license', title: 'Download an Instant Cloud license file', render }

export default DownloadCloudLicenseFile